<template>
	<div class="email-subscribers">
		<h1 class="left-align">List of users subscribed to email notifications</h1>
		<br/>
		<v-data-table
    :headers="headers"
    :items="emailSubscriberList"
    :items-per-page="25"
    class="elevation-1"
		dense
		:footer-props="footerProps"
  >
		<template v-for="h in headers" v-slot:[`header.${h.value}`]="{ header }">
			<span :key="h.value" class="columnTitleText" tabIndex="0" v-on:keyup.enter="(e) => e.target.click()">{{h.text}}</span>
		</template>
	</v-data-table>
	</div>
</template>

<script>
import { researcherApiService } from '@/services/researcherApiService.js';

export default {
	name: 'emailSubscribers',
	data () {
		return {
			emailSubscriberList: [],
			headers: [
				{ text: 'Email', value: 'email', class: 'data-table-header' },
				{ text: 'First Name', value: 'firstName', class: 'data-table-header' },
				{ text: 'Last Name', value: 'lastName', class: 'data-table-header' }
			],
			footerProps: {
				itemsPerPageOptions: [25, 50, 100, 150, 200, -1]
			}
		}
	},
	mounted () {
		researcherApiService.getUsersSubscribedToEmailNotifications().then(response => {
			this.emailSubscriberList = response.data;
		});
	}
}
</script>

<style>

</style>
